function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M109.458,3.647H97.5A1.686,1.686,0,0,1,96,1.824,1.686,1.686,0,0,1,97.5,0h11.962a1.686,1.686,0,0,1,1.5,1.824A1.686,1.686,0,0,1,109.458,3.647ZM97.5,1.216a.562.562,0,0,0-.5.608.562.562,0,0,0,.5.608h11.962a.562.562,0,0,0,.5-.608.562.562,0,0,0-.5-.608Z",
  transform: "translate(-96)",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.458,451.647H97.5a1.86,1.86,0,0,1,0-3.647h11.962a1.86,1.86,0,0,1,0,3.647ZM97.5,449.216a.62.62,0,0,0,0,1.216h11.962a.62.62,0,0,0,0-1.216Z",
  transform: "translate(-96 -423.637)",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.941,65.814a.594.594,0,0,1-.608-.579V60.392a5.106,5.106,0,0,1,1.869-3.92l2.679-2.231L119.2,52.009a5.106,5.106,0,0,1-1.869-3.92V43.246a.609.609,0,0,1,1.216,0v4.843A3.973,3.973,0,0,0,120,51.138l3.2,2.668a.559.559,0,0,1,0,.87L120,57.343a3.973,3.973,0,0,0-1.453,3.048v4.843A.594.594,0,0,1,117.941,65.814Z",
  transform: "translate(-116.117 -40.236)",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M293.471,65.814a.594.594,0,0,1-.608-.579V60.392a3.973,3.973,0,0,0-1.453-3.048l-3.2-2.668a.559.559,0,0,1,0-.87l3.2-2.668a3.969,3.969,0,0,0,1.453-3.048V43.246a.609.609,0,0,1,1.216,0v4.843a5.106,5.106,0,0,1-1.869,3.92l-2.679,2.231,2.679,2.231a5.1,5.1,0,0,1,1.869,3.92v4.843A.594.594,0,0,1,293.471,65.814Z",
  transform: "translate(-280.341 -40.236)",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.227,306.167h-6.808a.444.444,0,0,1-.384-.344.828.828,0,0,1,.051-.643l3.4-6.078a.364.364,0,0,1,.665,0l3.4,6.078a.828.828,0,0,1,.051.643A.442.442,0,0,1,167.227,306.167Zm-5.922-1.216h5.037l-2.519-4.5Z",
  transform: "translate(-156.347 -282.761)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.7,174.314a.611.611,0,0,1-.43-.178l-2.431-2.431a.608.608,0,0,1,.43-1.038h4.863a.609.609,0,0,1,.43,1.038l-2.431,2.431A.611.611,0,0,1,205.7,174.314Zm-.964-2.431.964.964.964-.964Z",
  transform: "translate(-198.22 -161.386)"
}));

function SvgIconHourglass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.953,
    height: 29.01,
    viewBox: "0 0 15.953 29.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHourglass);
export default __webpack_public_path__ + "static/media/icon-hourglass.9e95f477.svg";
export { ForwardRef as ReactComponent };